import { Link } from "react-router-dom";
import styles from "./layout.module.css";
import { TuneOutlined } from "@mui/icons-material";

const Footer = ({ menuName }) => {

  return (<footer className={`${styles.FooterMain}`}>
    <div className={`${styles.SideAvatarMain}`}>
      <Link to={"/driver/dashboard"}>
        <img src="/images/favicon.png" alt="" />
      </Link>
    </div>
    <div className={`${styles.SideMenuLinkSec}`}>
      <div className={`${styles.SideMenuLinkSecUnder}`}>
        <ul>
          <li className={menuName === "dashboard" ? `${styles.Active}` : ``}>
            <Link to={"/driver/dashboard"}>
              <TuneOutlined />
              <p className={`${styles.SideLinkText}`}>Booking List</p>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  </footer>);
};

export default Footer;